 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"admin-concepto-concepto-module":"admin-concepto-concepto-module","admin-retencion-retencion-module":"admin-retencion-retencion-module","ajuste-detail-ajuste-detail-module":"ajuste-detail-ajuste-detail-module","bodega-addedit-bodega-addedit-module":"bodega-addedit-bodega-addedit-module","caracteristica-addedit-caracteristica-addedit-module":"caracteristica-addedit-caracteristica-addedit-module","categoria-addedit-categoria-addedit-module":"categoria-addedit-categoria-addedit-module","common":"common","concepto-addedit-concepto-addedit-module":"concepto-addedit-concepto-addedit-module","contabilidad-auxiliares-auxiliares-module":"contabilidad-auxiliares-auxiliares-module","contabilidad-libro-mb-libro-mb-module":"contabilidad-libro-mb-libro-mb-module","contabilidad-plan-cuentas-plan-cuentas-module":"contabilidad-plan-cuentas-plan-cuentas-module","core-js-js":"core-js-js","dashboard-dashboard-module":"dashboard-dashboard-module","default~ajuste-addedit-ajuste-addedit-module~facturaCompra-comprobante-egreso-comprobante-egreso-add~3953774a":"default~ajuste-addedit-ajuste-addedit-module~facturaCompra-comprobante-egreso-comprobante-egreso-add~3953774a","ajuste-addedit-ajuste-addedit-module":"ajuste-addedit-ajuste-addedit-module","facturaCompra-comprobante-egreso-comprobante-egreso-addedit-comprobante-egreso-addedit-module":"facturaCompra-comprobante-egreso-comprobante-egreso-addedit-comprobante-egreso-addedit-module","facturaCompra-factura-factura-addedit-factura-addedit-module":"facturaCompra-factura-factura-addedit-factura-addedit-module","facturaVenta-factura-factura-addedit-factura-addedit-module":"facturaVenta-factura-factura-addedit-factura-addedit-module","facturaVenta-pago-pago-addedit-pago-addedit-module":"facturaVenta-pago-pago-addedit-pago-addedit-module","facturaVenta-recibo-caja-recibo-caja-addedit-recibo-caja-addedit-module":"facturaVenta-recibo-caja-recibo-caja-addedit-recibo-caja-addedit-module","informes-facturacion-facturacion-module":"informes-facturacion-facturacion-module","informes-inventario-inventario-module":"informes-inventario-inventario-module","produccion-produccion-module":"produccion-produccion-module","traslado-item-addedit-traslado-item-addedit-module":"traslado-item-addedit-traslado-item-addedit-module","default~fac-compras-ventas-fac-compras-ventas-module~fac-compras-ventas-factura-fac-compras-ventas-f~64e01111":"default~fac-compras-ventas-fac-compras-ventas-module~fac-compras-ventas-factura-fac-compras-ventas-f~64e01111","fac-compras-ventas-fac-compras-ventas-module":"fac-compras-ventas-fac-compras-ventas-module","fac-compras-ventas-factura-fac-compras-ventas-factura-module":"fac-compras-ventas-factura-fac-compras-ventas-factura-module","fac-compras-ventas-producto-fac-compras-ventas-producto-module":"fac-compras-ventas-producto-fac-compras-ventas-producto-module","informes-facturacion-fac-compras-ventas-producto-single-fac-compras-ventas-producto-single-module":"informes-facturacion-fac-compras-ventas-producto-single-fac-compras-ventas-producto-single-module","inv-bodega-existencia-inv-bodega-existencia-module":"inv-bodega-existencia-inv-bodega-existencia-module","inv-cuadre-caja-inv-cuadre-caja-module":"inv-cuadre-caja-inv-cuadre-caja-module","inv-cuadre-usuario-inv-cuadre-usuario-module":"inv-cuadre-usuario-inv-cuadre-usuario-module","inv-existencia-inv-existencia-module":"inv-existencia-inv-existencia-module","inv-traslados-agrupado-inv-traslados-agrupado-module":"inv-traslados-agrupado-inv-traslados-agrupado-module","inv-traslados-inv-traslados-module":"inv-traslados-inv-traslados-module","inv-ventas-utilidad-inv-ventas-utilidad-module":"inv-ventas-utilidad-inv-ventas-utilidad-module","default~item-addedit-item-addedit-module~tercero-addedit-tercero-addedit-module":"default~item-addedit-item-addedit-module~tercero-addedit-tercero-addedit-module","item-addedit-item-addedit-module":"item-addedit-item-addedit-module","tercero-addedit-tercero-addedit-module":"tercero-addedit-tercero-addedit-module","default~pos-pos-compra-pos-compra-module~pos-pos-venta-pos-venta-module":"default~pos-pos-compra-pos-compra-module~pos-pos-venta-pos-venta-module","pos-pos-compra-pos-compra-module":"pos-pos-compra-pos-compra-module","pos-pos-venta-pos-venta-module":"pos-pos-venta-pos-venta-module","dom-js":"dom-js","domiciliario-addedit-domiciliario-addedit-module":"domiciliario-addedit-domiciliario-addedit-module","domiciliario-detail-domiciliario-detail-module":"domiciliario-detail-domiciliario-detail-module","evento-addedit-evento-addedit-module":"evento-addedit-evento-addedit-module","facturaCompra-comprobante-egreso-comprobante-egreso-detail-comprobante-egreso-detail-module":"facturaCompra-comprobante-egreso-comprobante-egreso-detail-comprobante-egreso-detail-module","facturaCompra-comprobante-egreso-comprobante-egreso-module":"facturaCompra-comprobante-egreso-comprobante-egreso-module","facturaCompra-factura-factura-detail-factura-detail-module":"facturaCompra-factura-factura-detail-factura-detail-module","facturaCompra-factura-factura-module":"facturaCompra-factura-factura-module","facturaVenta-descuento-descuento-addedit-descuento-addedit-module":"facturaVenta-descuento-descuento-addedit-descuento-addedit-module","facturaVenta-descuento-descuento-module":"facturaVenta-descuento-descuento-module","facturaVenta-factura-factura-detail-factura-detail-module":"facturaVenta-factura-factura-detail-factura-detail-module","facturaVenta-factura-factura-module":"facturaVenta-factura-factura-module","facturaVenta-impuesto-impuesto-addedit-impuesto-addedit-module":"facturaVenta-impuesto-impuesto-addedit-impuesto-addedit-module","facturaVenta-impuesto-impuesto-module":"facturaVenta-impuesto-impuesto-module","facturaVenta-pago-pago-detail-pago-detail-module":"facturaVenta-pago-pago-detail-pago-detail-module","facturaVenta-pago-pago-module":"facturaVenta-pago-pago-module","facturaVenta-recibo-caja-recibo-caja-detail-recibo-caja-detail-module":"facturaVenta-recibo-caja-recibo-caja-detail-recibo-caja-detail-module","facturaVenta-recibo-caja-recibo-caja-module":"facturaVenta-recibo-caja-recibo-caja-module","facturaVenta-remision-remision-addedit-remision-addedit-module":"facturaVenta-remision-remision-addedit-remision-addedit-module","facturaVenta-remision-remision-detail-remision-detail-module":"facturaVenta-remision-remision-detail-remision-detail-module","facturaVenta-remision-remision-module":"facturaVenta-remision-remision-module","familia-addedit-familia-addedit-module":"familia-addedit-familia-addedit-module","inventario-ajuste-ajuste-module":"inventario-ajuste-ajuste-module","inventario-bodega-bodega-module":"inventario-bodega-bodega-module","inventario-caracteristica-caracteristica-module":"inventario-caracteristica-caracteristica-module","inventario-familia-categoria-familia-categoria-module":"inventario-familia-categoria-familia-categoria-module","inventario-inventario-inventario-module":"inventario-inventario-inventario-module","inventario-item-item-module":"inventario-item-item-module","inventario-stock-stock-module":"inventario-stock-stock-module","inventario-traslado-item-traslado-item-module":"inventario-traslado-item-traslado-item-module","inventario-unidad-medida-unidad-medida-module":"inventario-unidad-medida-unidad-medida-module","item-detail-item-detail-module":"item-detail-item-detail-module","login-login-module":"login-login-module","pedido-addedit-pedido-addedit-module":"pedido-addedit-pedido-addedit-module","pedido-detail-pedido-detail-module":"pedido-detail-pedido-detail-module","pedidos-carrito-carrito-module":"pedidos-carrito-carrito-module","pedidos-domiciliario-domiciliario-module":"pedidos-domiciliario-domiciliario-module","pedidos-evento-evento-module":"pedidos-evento-evento-module","pedidos-pedido-pedido-module":"pedidos-pedido-pedido-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","pos-factura-detail-pos-factura-detail-module":"pos-factura-detail-pos-factura-detail-module","pos-pos-factura-pos-factura-module":"pos-pos-factura-pos-factura-module","pos-pos-movimiento-pos-movimiento-module":"pos-pos-movimiento-pos-movimiento-module","pos-pos-settings-pos-settings-module":"pos-pos-settings-pos-settings-module","pos-pos-terminal-pos-terminal-module":"pos-pos-terminal-pos-terminal-module","pos-pos-turno-pos-turno-module":"pos-pos-turno-pos-turno-module","pos-terminal-addedit-pos-terminal-addedit-module":"pos-terminal-addedit-pos-terminal-addedit-module","pos-terminal-detail-pos-terminal-detail-module":"pos-terminal-detail-pos-terminal-detail-module","pos-turno-addedit-pos-turno-addedit-module":"pos-turno-addedit-pos-turno-addedit-module","pos-turno-detail-pos-turno-detail-module":"pos-turno-detail-pos-turno-detail-module","retencion-addedit-retencion-addedit-module":"retencion-addedit-retencion-addedit-module","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","shadow-css-d7d058ec-d59cb009-js":"shadow-css-d7d058ec-d59cb009-js","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom","tercero-detail-tercero-detail-module":"tercero-detail-tercero-detail-module","tercero-tercero-module":"tercero-tercero-module","traslado-item-detail-traslado-item-detail-module":"traslado-item-detail-traslado-item-detail-module","swiper-bundle-6c5e7804-js":"swiper-bundle-6c5e7804-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-ce03ee9f-js":"input-shims-ce03ee9f-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-9cb487b1-js":"status-tap-9cb487b1-js","swipe-back-1bbd08e0-js":"swipe-back-1bbd08e0-js","tap-click-7ddcdebb-js":"tap-click-7ddcdebb-js","pos-movimiento-addedit-pos-movimiento-addedit-module":"pos-movimiento-addedit-pos-movimiento-addedit-module","pos-movimiento-detail-pos-movimiento-detail-module":"pos-movimiento-detail-pos-movimiento-detail-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
